export default __webpack_public_path__ + "../sites/jinja2//site/svg/facebook.svg";